const white = [
  /* 登录 */
  '/userInfo/login',
  /* 发送验证码 */
  '/sendSmsCode',
  /* 检测账户名 */
  '/userInfo/checkUserName',
  /* 注册 */
  '/userInfo/createAccount',
  /* 忘记密码 */
  '/userInfo/forgetPwd',
  /* 首页菜单 */
  '/pmenu/category',
  /* 商品详情 */
  '/detail/data',
  /* 商品类型 */
  '/home/getAllCommodityType',
  /* 查询商品列表 */
  '/home/getCommodityList',
  /* 商品评价 */
  '/detail/review',
  /* 加载数据 */
  '/loadBaseData',
  /* 轮播图片 */
  '/home/getCarouselImg',
  /* 店铺详情 */
  '/shop/header',
  /* 店铺商品列表 */
  '/shop/data'
]

export default white